import React, { useEffect, useState } from 'react';
import ArrayFieldSection from './ArrayFieldSection';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { toast } from 'react-toastify';
import { getUser } from '../../pages/Login/authUtils'; // adjust path if needed


// Fix Leaflet marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const FormFieldRenderer = ({  field, formData, setFormData, dropdownData, readOnly, displayNameOnly }) => {
  const value = formData[field.fields] || '';
  const [latLng, setLatLng] = useState(null);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'number' ? parseInt(value, 10) : value,
    }));
  };

  // Fetch live location if field is location
  useEffect(() => {
    if (field.type === 'location') {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const coords = `${position.coords.latitude},${position.coords.longitude}`;
            setFormData((prev) => ({
              ...prev,
              [field.fields]: coords,
            }));
            setLatLng([position.coords.latitude, position.coords.longitude]);
          },
          (error) => {
            toast.error("❌ Location access denied.");
            console.error("Geolocation error:", error.message);
          }
        );
      } else {
        toast.error("Geolocation not supported.");
      }
    }
  }, [field.fields, field.type, setFormData]);

  useEffect(() => {
    const user = getUser();
    if (field.fields === 'CreatedBy' && user?._id) {
  
      setFormData((prev) => {
        if (!prev.CreatedBy || typeof prev.CreatedBy !== 'object') {
          return {
            ...prev,
            CreatedBy: {
              _id: user._id,
              name: user.name
            }
          };
        }
        return prev;
      });
    }
  }, [field.fields, setFormData]);
  
  
  
  
  

  if (field.subfields) {
    return (
      <ArrayFieldSection
        field={field}
        formData={formData}
        setFormData={setFormData}
        dropdownData={dropdownData}
      />
    );
  }

  const invalidKeys = ['e', 'E', '+', '-', '.'];

  return (
    <div className="form-group">
      <label className="form-label">{field.fields}</label>

      {field.api && field.type === 'ObjectId' ? (
        <select
          className="form-select"
          name={field.fields}
          value={value}
          onChange={handleChange}
          disabled={readOnly}
        >
          <option value="">Select {field.fields}</option>
          {dropdownData[field.fields]?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.label}
            </option>
          ))}
        </select>
      ) : field.options ? (
        <select
          className="form-select"
          name={field.fields}
          value={value}
          onChange={handleChange}
          disabled={readOnly}
        >
          <option value="">Select {field.fields}</option>
          {field.options.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ) : field.type === 'number' ? (
        <input
          className="form-input"
          type="number"
          name={field.fields}
          value={value}
          onChange={handleChange}
          inputMode="numeric"
          pattern="[0-9]*"
          onKeyDown={(e) => {
            if (
              invalidKeys.includes(e.key) ||
              e.key === ' ' ||
              (isNaN(Number(e.key)) && e.key.length === 1)
            ) {
              e.preventDefault();
            }
          }}
        />
      ) : field.type === 'date' ? (
        <input
          className="form-input"
          type="date"
          name={field.fields}
          value={value}
          onChange={handleChange}
        />
      ) : field.type === 'location' ? (
        <>
          {formData[field.fields] ? (
            <>
              <p><strong>📍 Location:</strong> {formData[field.fields]}</p>
              <a
                href={`https://www.google.com/maps?q=${formData[field.fields]}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block', borderRadius: '8px', overflow: 'hidden' }}
              >
                <MapContainer
                  center={latLng}
                  zoom={16}
                  scrollWheelZoom={false}
                  style={{ height: '250px', width: '100%' }}
                >
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <Marker position={latLng}>
                    <Popup>Selected Location</Popup>
                  </Marker>
                </MapContainer>
              </a>
            </>
          ) : (
            <>
              <input
                className="form-input"
                type="text"
                name={field.fields}
                value=""
                placeholder="No location set"
                readOnly
              />
              <button
                type="button"
                className="form-button"
                style={{ marginTop: '8px' }}
                onClick={() => {
                  if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                      (position) => {
                        const coords = `${position.coords.latitude},${position.coords.longitude}`;
                        setFormData((prev) => ({
                          ...prev,
                          [field.fields]: coords,
                        }));
                        setLatLng([position.coords.latitude, position.coords.longitude]);
                      },
                      (error) => {
                        toast.error("❌ Location access denied.");
                        console.error("Geolocation error:", error.message);
                      }
                    );
                  } else {
                    toast.error("Geolocation not supported.");
                  }
                }}
              >
                📍 Set Current Location
              </button>
            </>
          )}
        </>      
      ) : displayNameOnly && field.fields === "CreatedBy" ? (
        <input
          className="form-input"
          type="text"
          value={formData?.CreatedBy?.name || ''}
          readOnly
        />
      ) : (
        <input
          className="form-input"
          type="text"
          name={field.fields}
          value={value}
          onChange={handleChange}
          readOnly={field.fields === 'CreatedBy'}
        />
      )}

    </div>
  );
};

export default FormFieldRenderer;
